<template>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" @close="close" :close-on-click-modal="false" :close-on-press-escape="false" width="1100px">
        <el-form size="small" :model="form" :label-width="formLabelWidth" ref="form">

            <div class="common-form">基本信息</div>
            <el-descriptions class="margin-top" title="" :column="3" size="medium" border>
                <el-descriptions-item>
                    <template slot="label">活动标题</template>
                    {{ detail.activity ? detail.activity.title : '' }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">活动类型</template>
                    {{ detail.activity ? detail.activity.activity_type_desc : '' }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">参与人</template>
                    {{ detail.name ? detail.name : '' }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">联系电话</template>
                    {{ detail.mobile ? detail.mobile : '' }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">参与时间</template>
                    {{ detail.create_time ? detail.create_time : '' }}
                </el-descriptions-item>
            </el-descriptions>

            <div class="common-form" v-if="detail.enroll_desc">参与类型</div>
            <el-descriptions v-if="detail.enroll_desc" class="margin-top" title="" :column="1" size="medium" border>
                <el-descriptions-item>
                    <template slot="label">参与类型</template>
                    {{ detail.enroll_desc ? detail.enroll_desc : '' }}
                </el-descriptions-item>
            </el-descriptions>

            <div class="common-form" v-if="detail.activity_type === 1">参与信息</div>
            <el-descriptions v-if="detail.activity_type === 1" class="margin-top" title="" :column="1" size="medium" border>

                <el-descriptions-item>
                    <template slot="label">标题</template>
                    {{ detail.title }}
                </el-descriptions-item>

                <el-descriptions-item>
                    <template slot="label">封面</template>
                    <el-image style="height: 40px" fit="contain" v-if="detail.file_path" class="ya-img-table" :src="detail.file_path"
                              :preview-src-list="[detail.file_path]" title="点击查看大图"/>
                </el-descriptions-item>

                <el-descriptions-item v-if="detail.media_type == 1">
                    <template slot="label">作品</template>
                    <el-image style="height: 40px" fit="contain" v-if="item.file_path" class="ya-img-table" :src="item.file_path"
                              :preview-src-list="[item.file_path]" title="点击查看大图" v-for="(item,index) in detail.image_list" :key="index"/>
                </el-descriptions-item>
                <el-descriptions-item v-if="detail.media_type == 2">
                    <template slot="label">视频链接</template>
                    <el-link type="primary">{{detail.video.file_path}}</el-link>
                </el-descriptions-item>

                <el-descriptions-item>
                    <template slot="label">说明</template>
                    {{ detail.remark }}
                </el-descriptions-item>

                <el-descriptions-item v-if="detail.video_id > 0">
                    <template slot="label">视频</template>
                    <video ref="video" v-if="detail.video_id > 0" width="50%" height="50%" controls>
                        <source :src="detail.video_url" type="video/mp4">
                        <object :data="detail.video_url" width="100%" height="100%">
                            <embed :src="detail.video_url" width="100%" height="100%">
                        </object>
                    </video>
                </el-descriptions-item>

            </el-descriptions>

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="save" :disabled="submit_loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {enrollDetail} from '@/api/education';

    export default {
        components: {},
        data() {
            return {
                title: '详情',
                file_path: '',
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                dialogFormVisible: false,
                /*是否正在提交*/
                submit_loading: false,

                form: {},
                enroll_id: '',
                detail: []
            };
        },
        props: ['fetch-data'],
        created() {

        },
        methods: {
            showDialog(row) {
                if (!row) {
                    this.$message({message: '获取详情失败', type: 'error'});
                } else {
                    this.enroll_id = row.enroll_id
                    this.getDetail()
                }
                this.detail.video_id = 0;
                this.dialogFormVisible = true
            },
            save() {
                this.close()
            },
            // 关闭
            close() {
                this.$refs['form'].resetFields()
                this.form = this.$options.data().form
                if(this.detail.video_id > 0){
                    this.$refs['video'].pause()
                }
                this.dialogFormVisible = false
            },
            getDetail() {
                enrollDetail({id: this.enroll_id}).then((result) => {
                    this.detail = Object.assign({}, result.data)
                    if(this.detail.video_id > 0){
                        this.detail.video_url = result.data.video.file_path
                    }
                })
            },

        }
    };
</script>

<style scoped>
    .tips {
        color: #ccc;
    }
</style>



// WEBPACK FOOTER //
// src/views/education/activity/enroll/detail.vue